/** Side-by-side trend panels — portfolio compare metaphor. */
export const CompareIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="2.5" y="5" width="8" height="14" rx="2" />
    <path d="M4.5 15.5 6.5 11.5 8 13" />
    <rect x="13.5" y="5" width="8" height="14" rx="2" />
    <path d="M15.5 13 17.5 9 19 10.5" />
    <path d="M12 8v8" strokeDasharray="2.5 2.5" opacity="0.55" />
  </svg>
);
